module.exports = __webpack_public_path__ + "img/f_4.21481a95.png";